import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

interface MessageConfig {
  ok?: string;
  error?: string;
  info?: string;
  locationOk?: string;
  locationError?: string;
}

@Component({
  selector: 'ca-row-result',
  templateUrl: './row-result.component.html',
  styleUrls: ['./row-result.component.scss']
})
export class RowResultComponent {
  @Input() ok: boolean;
  @Input() messages: MessageConfig = {};
  @Input() result: any;
  @Output() retry = new EventEmitter();
  hover = false;
  locationHover = false;

  @HostListener('click')
  onRetry() {
    this.retry.emit(this.result);
  }

  tooltip() {
    if (this.ok) {
      return this.messages.ok;
      // return 'Imported OK!';
    }
    return this.messages.error;
    // return 'Import failed. Please try creating this item manually.';
  }

  locationTooltip() {
    if (this.ok) {
      return this.messages.locationOk;
      // return 'Imported OK!';
    }
    return this.messages.locationError;
    // return 'Import failed. Please try creating this item manually.';
  }
}
